import { gql } from '@apollo/client';

export const TASK_LIGHT_FRAGMENT = gql`
  fragment TaskLight on TaskObject {
    id
    taskId
    title
    description
    updatedAt
    assignee
    priority
    folder
    following
    unread
    dueDate
    overdue
  }
`;

export const COMMENT_FIELDS = gql`
  fragment TaskCommentFields on TaskCommentObject {
    id
    createdBy
    body
    bodyJson
    createdAt
    editedAt
    mentions
    replyTo
    deletedAt
  }
`;
